import Alert, { AlertProps } from '@mui/material/Alert';

const AlertText = (props: AlertProps) => <Alert {...props} sx={{ backgroundColor: 'transparent' }} />;

export default AlertText;
